import { fetchLists, deleteList } from './bao-swym.js'

class WishlistBlock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.initWishlistBlock()
  }

  setupListeners () {
    window.addEventListener('PandectesEvent_OnConsent', e => {
      if (e.detail.consentType === 'new' || e.detail.consentType === 'stored') {
        this.initWishlistBlock()
      }
    })
  }

  initWishlistBlock () {
    window.SwymCallbacks.push(() => {
      fetchLists(false).then(lists => {
        this.renderBlocks(lists)
      })
    })
  }

  removeList (listId, element) {
    deleteList(listId)
      .then(() => {
        element.remove()
      })
      .catch(err => {
        console.error(err)
      })
  }

  renderBlocks (lists) {
    this.els.container.element.innerHTML = ''

    lists.forEach(list => {
      const listBlock = document.createElement('div')

      const listTitle = document.createElement('h2')
      listTitle.innerText = `${list.lname} (${list.listcontents.length})`
      listTitle.classList.add('wsh-WishlistBlock_Title')

      listBlock.classList.add('wsh-WishlistBlock')
      listBlock.appendChild(listTitle)

      const listContents = document.createElement('div')
      listContents.classList.add('wsh-WishlistBlock_Contents')

      const { listcontents } = list

      listcontents.slice(0, 3).forEach(item => {
        const itemBlock = document.createElement('a')
        itemBlock.href = item.du
        itemBlock.classList.add('wsh-WishlistBlock_Item')

        const itemImage = document.createElement('img')
        itemImage.src = item.iu
        itemImage.alt = item.dt
        itemImage.classList.add('wsh-WishlistBlock_ItemImage')
        itemBlock.appendChild(itemImage)

        listContents.appendChild(itemBlock)
      })

      listBlock.appendChild(listContents)

      const listButton = document.createElement('a')
      listButton.href = `/pages/wishlist?lid=${list.lid}&name=${list.lname}`
      listButton.innerText = 'View Wish List'
      listButton.classList.add('wsh-WishlistBlock_Button')
      listButton.classList.add('btn-Button')
      listButton.classList.add('btn-Button-primary')

      const listRemoveButton = document.createElement('button')
      listRemoveButton.classList.add('wsh-WishlistBlock_RemoveButton')
      listRemoveButton.type = 'button'
      listRemoveButton.setAttribute(
        'aria-label',
        window.theme.strings.wishlist.removeList,
      )
      listRemoveButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 10">
          <path fill="currentColor" d="m1.695.308 8.975 8.975-.716.716L.979 1.024z"/>
          <path fill="currentColor" d="M10.668.715 1.692 9.691l-.716-.717L9.951 0z"/>
        </svg>
      `
      listRemoveButton.addEventListener('click', () => {
        this.removeList(list.lid, listBlock)
      })
      listRemoveButton.classList.add('wsh-WishlistBlock_Remove')

      listBlock.appendChild(listButton)
      listBlock.appendChild(listRemoveButton)

      this.els.container.element.appendChild(listBlock)
    })
  }
}

if (!customElements.get('wishlist-blocks')) {
  customElements.define('wishlist-blocks', WishlistBlock)
}
